import * as React from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";

interface ILabelStat {
  className?: string;
  label?: string;
  value?: number | string;
  black?: boolean;
}

const LabelStat = styled(({ className, label, value }: ILabelStat) => (
  <div className={className}>
    <label>{label}</label>
    <span>{value}</span>
  </div>
))`
  text-transform: uppercase;
  font-family: ${theme.fontFamily.bold};
  font-size: 16px;
  font-weight: 500;
  label {
    color: ${theme.color.primary};
    margin-right: 20px;
  }
  span {
    color: ${theme.color.primary};
  }
`;

export default LabelStat;



// WEBPACK FOOTER //
// ./src/components/common/LabelStat.tsx